/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_AnyInputs */

const cs_gdpr_audit_any = /** @type {(inputs: Gdpr_Audit_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše`)
};

const en_gdpr_audit_any = /** @type {(inputs: Gdpr_Audit_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any`)
};

/**
* | output |
* | --- |
* | "Any" |
*
* @param {Gdpr_Audit_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_any = /** @type {((inputs?: Gdpr_Audit_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_any(inputs)
	return cs_gdpr_audit_any(inputs)
});